import React from 'react';
import { Progress } from 'reactstrap';

import './ExperienceBar.css';

const ExperienceBar = ({ levelData }) => {
  const {
    currentLevel,
    experienceInLevel,
    experienceToNextLevel,
    progressRatio
  } = levelData;

  const progressPercent = (experienceInLevel / experienceToNextLevel) * 100;
  const isInside = progressPercent >= 15;

  return (
    <div style={{ padding: '10px 30px', width: '100%', maxWidth: '400px' }}>
      <div className="d-flex justify-content-between mb-1">
        <div style={{ fontSize: '14px' }}>{`Lv${currentLevel}`}</div>
        <div style={{ fontSize: '12px' }}>{`(${experienceInLevel}/${experienceToNextLevel})`}</div>
      </div>
      <div style={{ position: 'relative' }}>
        <Progress value={progressRatio * 100} style={{ height: '10px', borderRadius: '10px' }} color="info" />
        <div style={{
          position: 'absolute',
          top: 0,
          //left: `${(experienceInLevel / experienceToNextLevel) * 50}%`,
          left: isInside ? `${progressPercent/2}%` : `${50+progressPercent/2}%`,
          transform: isInside ? 'translateX(-50%)' : 'translateX(-50%)',
          color: isInside ? 'white' : 'black',
          fontSize: '9px',
          lineHeight: '100%', // aligns with bar height
          height: '100%',
          display: 'flex',
          alignItems: 'center'
        }}>
          {`${Math.floor((experienceInLevel / experienceToNextLevel) * 100)}%`}
        </div>
      </div>
    </div>
  );
};

export default ExperienceBar;